import {Group, Select} from '@mantine/core'
import {useQuery} from '@tanstack/react-query'
import {useNavigate, useSearch} from '@tanstack/react-router'

import {getOrganization} from 'src/api/client/api'

type ManagerFilterProps = {
    orgId: string
}

const ALL_MANAGERS = ''
const UNMANAGED = '__unmanaged__'

export function ManagerFilter({orgId}: ManagerFilterProps) {
    const navigate = useNavigate()
    const {manager} = useSearch({strict: false})
    const {data: org} = useQuery({
        queryKey: ['organization', orgId],
        queryFn: () => getOrganization(orgId),
    })

    const managers = org?.managers ?? []
    const options = [
        {value: ALL_MANAGERS, label: 'All Managers'},
        {value: UNMANAGED, label: 'Unmanaged'},
        ...managers.map((m) => ({value: m, label: m})),
    ]

    if (managers.length === 0) return null

    return (
        <Group>
            <Select
                label="Manager"
                data={options}
                value={manager ?? ALL_MANAGERS}
                onChange={(v) =>
                    navigate({
                        to: '.',
                        search: {manager: v === ALL_MANAGERS ? undefined : (v ?? '')},
                        replace: true,
                    })
                }
                clearable={false}
                size="sm"
                w={200}
            />
        </Group>
    )
}
